import React, { useState } from "react";

import MyHealthTiles from "../../components/patient2/myhealth/MyHealthTiles";
import MyHealthAppointments from "../../components/patient2/myhealth/MyHealthAppointments";
import MyHealthDocuments from "../../components/patient2/myhealth/MyHealthDocuments";
import MyHealthMessages from "../../components/patient2/myhealth/MyHealthMessages";
import MyHealthReviews from "../../components/patient2/myhealth/MyHealthReviews";

export default function MyHealthScreen({
  appointmentsUpcoming = [],
  appointmentsPast = [],
  documents = [],
  unreadMessages = 0,
  reviewsPending = [],
  reviewsRecent = [],

  onOpenAppointment,
  onUploadDocument,
  onOpenDocument,
  onOpenMessages,
  onGoToAppointments, // optional – still passed to tiles
  onGoToDocuments,
  onGoToReviews,
  onWriteReview,
}) {
  const [activeGroup, setActiveGroup] = useState("all"); // "all" | "appointments" | "documents" | "messages" | "reviews"

  const appointmentsCount =
    (appointmentsUpcoming?.length || 0) +
    (appointmentsPast?.length || 0);

  const documentsCount = documents?.length || 0;
  const reviewsCount = reviewsRecent?.length || 0;

  const groups = [
    { id: "all", label: "Të gjitha" },
    { id: "appointments", label: "Takime" },
    { id: "documents", label: "Dokumente" },
    { id: "messages", label: "Mesazhe" },
    { id: "reviews", label: "Vlerësime" },
  ];

  return (
    <div className="p2-myhealth-root">
      {/* Header text */}
      <div className="p2-myhealth-header">
        <h1 className="p2-myhealth-header-title">
          Shëndeti im
        </h1>
        <p className="p2-myhealth-header-sub">
          Takimet, dokumentet, mesazhet dhe vlerësimet e tua në një vend.
        </p>
      </div>

      {/* Summary tiles */}
      <MyHealthTiles
        appointmentsCount={appointmentsCount}
        documentsCount={documentsCount}
        messagesUnread={unreadMessages}
        reviewsCount={reviewsCount}
        onAppointments={onGoToAppointments}
        onDocuments={onGoToDocuments}
        onMessages={onOpenMessages}
        onReviews={onGoToReviews}
      />

      {/* Group selector / sub-tabs */}
      <div className="p2-myhealth-groups">
        {groups.map((g) => (
          <button
            key={g.id}
            type="button"
            className={
              "p2-myhealth-group-chip" +
              (activeGroup === g.id ? " p2-myhealth-group-chip--active" : "")
            }
            onClick={() => setActiveGroup(g.id)}
          >
            {g.label}
          </button>
        ))}
      </div>

      {/* Appointments */}
      {(activeGroup === "all" || activeGroup === "appointments") && (
        <MyHealthAppointments
          upcoming={appointmentsUpcoming}
          past={appointmentsPast}
          onOpenAppointment={onOpenAppointment}
        />
      )}

      {/* Documents */}
      {(activeGroup === "all" || activeGroup === "documents") && (
        <MyHealthDocuments
          documents={documents}
          onUpload={onUploadDocument}
          onOpenDocument={onOpenDocument}
        />
      )}

      {/* Messages */}
      {(activeGroup === "all" || activeGroup === "messages") && (
        <MyHealthMessages
          unreadCount={unreadMessages}
          onOpen={onOpenMessages}
        />
      )}

      {/* Reviews */}
      {(activeGroup === "all" || activeGroup === "reviews") && (
        <MyHealthReviews
          pending={reviewsPending}
          recent={reviewsRecent}
          onWriteReview={onWriteReview}
        />
      )}
    </div>
  );
}
